type FinallyFunction = null | (() => void);

/**
 * Short version of try and catch
 * @param promise
 * @param finallyFunction
 * @param throwIfError
 * @returns {*}
 */
export async function tryAndCatch<Type>(
  promise: Promise<Type>,
  finallyFunction: FinallyFunction = null,
  throwIfError = false,
): Promise<[Type, null] | [null, { data?: { message?: string } } & Error]> {
  try {
    const result = await promise;
    return [result, null];
  } catch (error) {
    if (throwIfError) {
      throw error;
    }
    return [null, error as unknown as Error];
  } finally {
    if (finallyFunction !== null) {
      if (typeof finallyFunction === 'function') {
        finallyFunction();
      }
    }
  }
}

export type ErrorType = {
  message: string;
  status: number;
};
